"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as o } from "react";
import a from "../components/Icon/SvgIcon.js";
const m = (c) => /* @__PURE__ */ l(
  a,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...c,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.765 15.417v-2.509c0-.054-.007-.332-.059-.405-.075-.104-.259-.18-.341-.213l-.034-.015-.334-.14c-.527-.222-1.498-.63-1.552-.665l-.008-.005a.44.44 0 0 1-.16-.16 118 118 0 0 1-1.143-2.055c-.09-.183-.186-.31-.382-.31H15.11V7.357c0-.473-.326-.857-.728-.857H2.971c-.402 0-.728.384-.728.857v8.057a.3.3 0 0 0-.243.294v.408c0 .17.135.306.303.306h1.183l-.002-.04-.003-.062c0-.133.02-.26.042-.387.033-.185.082-.364.158-.53 0 0 .593-1.296 2.048-1.296 1.156 0 2.091.918 2.153 2.07v.206l-.003.039h8.409l-.001-.016-.002-.022-.002-.064c0-.131.021-.244.045-.367l.005-.024c.196-1.041 1.085-1.817 2.153-1.817.898 0 1.663.55 1.999 1.333.064.148.117.303.148.466a2.2 2.2 0 0 1 .036.48l-.002.03h1.031a.304.304 0 0 0 .302-.306v-.407a.3.3 0 0 0-.235-.291m-17.62 1.011a1.53 1.53 0 0 1 1.522-1.536c.838 0 1.52.689 1.52 1.536a1.53 1.53 0 0 1-1.52 1.537 1.53 1.53 0 0 1-1.521-1.537m.668 0a.86.86 0 0 0 .854.864.86.86 0 0 0 .854-.864.86.86 0 0 0-.854-.863.86.86 0 0 0-.854.863m13.664-1.536a1.53 1.53 0 0 0-1.52 1.536 1.53 1.53 0 0 0 1.52 1.537 1.53 1.53 0 0 0 1.52-1.537 1.53 1.53 0 0 0-1.52-1.536m-.854 1.536a.86.86 0 0 0 .854.864.86.86 0 0 0 .854-.864.86.86 0 0 0-.854-.863.86.86 0 0 0-.854.863m-1.867-4.79h2.57c.14-.005.135-.123.117-.164a199 199 0 0 0-.767-1.614l-.01-.022c-.034-.068-.055-.112-.121-.112h-1.789a.13.13 0 0 0-.131.134v1.645c0 .073.06.132.131.132",
        clipRule: "evenodd"
      }
    )
  }
), i = o(m);
export {
  i as TruckSolid,
  i as default
};
